/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:22:19
 * @Description: Element
 */

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

export default ElementUI;
